import styled from '@emotion/styled';

const PageContainer = styled.div`
    margin-top: ${(props) => props.theme.spaces.navbarHeight};
    width: 100%;
`;

export default PageContainer;
